import { MatchupPrediction } from "../models";
import "./WinProbability.css";

interface WinProbabilityProps {
	prediction: MatchupPrediction;
	inverted?: boolean;
}

export const WinProbability = ({ prediction, inverted }: WinProbabilityProps) => (
	<div className={inverted ? "winprob inverted" : "winprob"} title="Estimated from FPL expected points for the players still to play">
		<div className="winprob-labels">
			<span>WIN · {prediction.home}%</span>
			<span>DRAW · {prediction.draw}%</span>
			<span>WIN · {prediction.away}%</span>
		</div>
		<div className="winprob-bar" role="img" aria-label={`Home ${prediction.home}%, draw ${prediction.draw}%, away ${prediction.away}%`}>
			<div className="winprob-home" style={{ width: `${prediction.home}%` }} />
			<div className="winprob-draw" style={{ width: `${prediction.draw}%` }} />
			<div className="winprob-away" style={{ width: `${prediction.away}%` }} />
		</div>
	</div>
);
